document.addEventListener('DOMContentLoaded', function () {
  function isDesktop() {
    return window.innerWidth >= 750;
  }

  var menuDetails = document.querySelectorAll('header-menu details');

  menuDetails.forEach(function (details) {
    var summary = details.querySelector('summary');
    var closeTimeout;

    // Prevent the native click-to-toggle on desktop so hover fully controls it
    if (summary) {
      summary.addEventListener('click', function (e) {
        if (isDesktop()) {
          e.preventDefault();
        }
      });
    }

    details.addEventListener('mouseenter', function () {
      if (!isDesktop()) return;
      clearTimeout(closeTimeout);
      details.setAttribute('open', '');
    });

    details.addEventListener('mouseleave', function () {
      if (!isDesktop()) return;
      closeTimeout = setTimeout(function () {
        details.removeAttribute('open');
      }, 150);
    });
  });
});
